<template>
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.42498 9.29199H6.21665C5.69165 9.29199 5.26666 9.71695 5.26666 10.242V14.5086H8.42498V9.29199V9.29199Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.6344 5.5H9.36771C8.84271 5.5 8.41772 5.92501 8.41772 6.45001V14.5H11.5761V6.45001C11.5761 5.92501 11.1594 5.5 10.6344 5.5Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.7901 10.708H11.5818V14.4997H14.7401V11.658C14.7318 11.133 14.3068 10.708 13.7901 10.708Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.50002 18.3337H12.5C16.6667 18.3337 18.3334 16.667 18.3334 12.5003V7.50033C18.3334 3.33366 16.6667 1.66699 12.5 1.66699H7.50002C3.33335 1.66699 1.66669 3.33366 1.66669 7.50033V12.5003C1.66669 16.667 3.33335 18.3337 7.50002 18.3337Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

</template>

<script>
export default {
  name: 'UserIcon',
  props: {
    isActive: Boolean,
  },
  data() {
    return {
      
    }

  },

};
</script>
